import { DndProvider } from 'react-dnd';
import { HTML5Backend } from 'react-dnd-html5-backend';
import { Outlet } from 'react-router-dom';
import { AccountSettings } from '~/components/users/settings/account';
import { UserSettings } from '~/components/users/settings/user';
import { ActivityIndicatorProvider } from '~/layouts/nav/MainNav';

export const DefaultLayout = () => {
  return (
    <>
      <DndProvider backend={HTML5Backend}>
        <ActivityIndicatorProvider>
          <Outlet />
          {/* Settings overlays are mounted globally so hash toggles work everywhere */}
          <UserSettings />
          <AccountSettings />
        </ActivityIndicatorProvider>
      </DndProvider>
    </>
  );
};
